import script from "./GameLoader.vue?vue&type=script&setup=true&lang=ts"
export * from "./GameLoader.vue?vue&type=script&setup=true&lang=ts"

import "./GameLoader.vue?vue&type=style&index=0&id=d43c4354&lang=css"

const __exports__ = script;

export default __exports__